import TableQrList from './views/tableQrList.vue';
import TableQr from './TableQr.vue';

export const tableQrRoutes = [
  {
    path: 'tableQr',
    component: TableQr,
    children: [
      { path: '', component: TableQrList, name: 'tableQr', }
    ]
  }
];
